<script lang="ts">
	import uqnSplit from './functions/uqnSplit';
	import Fraction from './functions/fractionClass';
	import katexify from './functions/katexify';
	//import brackets from './functions/brackets';

	export let uqn: number;

	let first: string, second: string; //third: string, fourth: string;
	let type: number, direct: number, k: number, double: number;
	$: [type, direct, k, double] = uqnSplit(uqn);
	$: [first, second] = uqnToQn2201(uqn);

	function uqnToQn2201(u:number):string[]{
		const [type, direct, k, double] = uqnSplit(u);
		let x = type==4 ? 2 : 1;
		let y = direct < 4 ? new Fraction(k*x,1) : new Fraction(k,x);
		let second: string;
		if (direct%2==0){ // words
			const words = ['one quarter of its original value', 'halved', 'doubled', 'tripled', 'quadrupled'];
			second = words[double];
		} else{ // percentage
			const percentages = ['decreased by 75%', 'decreased by 50%', 'increased by 100%', 'increased by 200%', 'increased by 300%'];
			second = percentages[double];
		}
		return [y.toString(), second]
	}
</script>

<p>
	It is given that {@html katexify('y')} is
	{#if direct<4}
		directly
	{:else}
		inversely
	{/if}
	proportional to
	{#if type==1}
	{@html katexify(`x`)}
	{:else if type==2}
	the square of {@html katexify(`x.`)}
	{:else if type==3}
	the cube of {@html katexify(`x.`)}
	{:else if type==4}
	{@html katexify(`x+1.`)}
	{:else if type==5}
	the square root of {@html katexify(`x.`)}
	{:else}
	the cube root of {@html katexify(`x.`)}
	{/if}
</p>
{#if direct%4 < 2}
	<p>
		It is known that {@html katexify(`y=${first}`)} for a particular value of {@html katexify('x.')}
	</p>
	<p>
		Find the value of {@html katexify('y')} when the value of {@html katexify('x')} is
		{#if direct%2==0}
			{second}.
		{:else}
			is {second}.
		{/if}
	</p>
{:else}
<p>
	Find the percentage
	{#if ( (double>1 && direct<4) || (double<2&&direct>3) )}
		increase
	{:else}
		decrease
	{/if}
	in {@html katexify('y')} if the value of the value of {@html katexify('x')} is
	{#if direct%2==0}
		{second}.
	{:else}
		is {second}.
	{/if}
</p>
{/if}



